<template>
    <page :busy="busy" :tabs="tabs">
        <grid
            ref="grid"
            :columnDefs="columnDefs"
            :fetchCallback="fetchCallback"
            :maxBlocksInCache="null"
            :defaultSort="sort"
        >
            <div class="toolbar">
                <b-button-group aria-label="Export table data">
                    <responsive-button
                        :icon="['fas', 'file-excel']"
                        :href="exportExcelHref"
                        @click="generatingExcelReportSuccessToast"
                        variant="primary"
                    ></responsive-button>
                </b-button-group>
                <responsive-button
                    :icon="['fas', 'arrows-rotate']"
                    @click="refresh"
                    variant="primary"
                >Refresh</responsive-button>
                <responsive-button
                    :icon="['fas', 'plus']"
                    variant="primary"
                    @click="handleCreateTeamMemberClick"
                >Add Team Member</responsive-button>
            </div>
        </grid>
    </page>
</template>

<script>
    import API from '../../../api';
    import Grid from '../../generic/grid/grid.vue';
    import Page from '../../generic/page/page.vue';
    import ResponsiveButton from '../../generic/responsive-button/responsive-button.vue';
    import ActionsCellRenderer from './actions-cell-renderer.vue';
    import { removeScrollMixin } from '../../../mixins/remove-scroll-mixin';
    import { TEAM_MEMBER_LIST_ENDPOINT, TEAM_MEMBER_LIST_EXCEL_ENDPOINT } from '../../../endpoints';

    export default {
        name: 'TeamMemberList',
        mixins: [removeScrollMixin],
        components: {
            Grid,
            Page,
            ResponsiveButton,
            actionsCellRenderer: ActionsCellRenderer,
        },
        computed: {
            fetchCallback() {
                return ({ offset, limit, sort, desc, search }) => {
                    this.offset = offset;
                    this.limit = limit;
                    this.sort = sort;
                    this.desc = desc;
                    this.search = search;
                    return API.get(TEAM_MEMBER_LIST_ENDPOINT(), {
                        params: {
                            offset,
                            limit,
                            sort,
                            desc,
                            search,
                        }
                    });
                };
            },
            exportExcelHref() {
                let url = TEAM_MEMBER_LIST_EXCEL_ENDPOINT()
                url += `?offset=${this.offset}`
                url += `&limit=${this.limit}`
                url += `&sort=${this.sort}`
                url += `&desc=${this.desc}`
                url += `&search=${this.search}`
                return url
            },
        },
        data() {
            return {
                busy: false,
                tabs: [
                    {
                        'title': 'Team Members',
                        'route': '/app/team-member/list/',
                        'active': true
                    }
                ],
                columnDefs: [
                    {
                        field: 'id',
                        type: 'idColumn',
                        maxWidth: 80,
                        sort: undefined,
                    },
                    {
                        field: 'date_joined',
                        headerName: 'Created',
                        type: 'dateTimeColumn',
                        minWidth: 250,
                    },
                    {
                        field: 'first_name',
                        headerName: 'First Name',
                        minWidth: 140,
                    },
                    {
                        field: 'last_name',
                        headerName: 'Last Name',
                        minWidth: 140,
                    },
                    {
                        field: 'email',
                        headerName: 'Email',
                        minWidth: 140,
                    },
                    {
                        type: 'yesNoColumn',
                        field: 'is_active',
                        headerName: 'Active',
                        minWidth: 100,
                        maxWidth: 100,
                    },
                    {
                        type: 'yesNoColumn',
                        field: 'is_validated',
                        headerName: 'Validated',
                        minWidth: 100,
                        maxWidth: 100,
                    },
                    {
                        field: 'group',
                        headerName: 'Group',
                        minWidth: 140,
                    },
                    {
                        headerName: '',
                        minWidth: 220,
                        maxWidth: 220,
                        resizable: false,
                        sortable: false,
                        cellStyle: { textAlign: 'center' },
                        cellRenderer: 'actionsCellRenderer',
                    },
                ],
                offset: 0,
                limit: 20,
                sort: 'order',
                desc: false,
                search: '',
            }
        },
        methods: {
            handleCreateTeamMemberClick() {
                this.$router.push(`/app/team-member/create/`);
            },
            refresh() {
                this.$refs.grid.refreshDataSource();
            }
        },
    }
</script>

<style scoped lang="scss">
    .toolbar {
        display: flex;
        flex-direction: row;
        align-items: center;
    }
</style>
